<template>
  <div class="map-item-wrapper">
    <el-row :gutter="10" align="middle">
      <el-col :span="4">
        <div class="map-thumb-wrapper">
          <el-image :src="mapPlaceholder" style="border-radius: 4px" />
        </div>
      </el-col>
      <el-col :span="20">
        <div class="card-wrap">
          <div class="map-name">
            <el-link @click="openMapDetail">
              <el-text>
                {{ map.name }}
              </el-text>
            </el-link>
          </div>
          <div class="card-actions">
            <el-button link @click="toggleMapVisibleOnEarth">
              <el-icon v-if="visible"><View /></el-icon>
              <el-icon v-else><Hide /></el-icon>
            </el-button>
            <el-button icon="Delete" link @click="deleteFromEarth" />
            <el-button icon="Refresh" @click="refreshMapOnEarth" link />            
          </div>
        </div>
      </el-col>
    </el-row>

    <KeepAlive>
      <map-detail
        ref="mapDetailRef"
        :map="map"
        :index="index"
        v-show="mapDetailVisible"
        @close="closeMapDetail"
      ></map-detail>
    </KeepAlive>
  </div>
</template>
<script>

import mapPlaceholder from "@/assets/images/map-placeholder.png" 
import MapDetail from '@/components/maps/MapDetail';

export default {
  components: {
    MapDetail,
  },
  props: {
    index: Number,
    map: Object,
  },
  data() {
    return {
      mapPlaceholder,
      mapDetailVisible: false,
    };
  },
  computed: {
    visible() {
      return this.map.visible;
    },
    earthLayer() {
      return {
        uid: this.map.name,
        layerServiceInfo: {
          url: this.map.url,
        },
      };
    },
  },
  methods: {
    deleteFromEarth() {
      this.$store.dispatch('importMaps/removeFromEarth', this.map);
      this.$EventBus.emit('globaluncheckedLayer', this.earthLayer);
    },
    //控制已上球地图是否可见
    toggleMapVisibleOnEarth() {
      const visible = !this.visible;
      if (visible) {
        this.$EventBus.emit('globalshowLayer', this.index);
      } else {
        this.$EventBus.emit('globalhideLayer', this.index);
      }
      this.$store.dispatch('maps/toggleMapVisible', {
        mapId: this.map.id,
        visible,
      });
    },
    refreshMapOnEarth() {
      if (this.visible) {
        this.$EventBus.emit('globalrefreshLayer', this.earthLayer);
        this.$refs.mapDetailRef.recoverLayerOptions();
      }
    },
    openMapDetail() {
      this.mapDetailVisible = true;
    },
    closeMapDetail() {
      this.mapDetailVisible = false;
    },
  },
};
</script>
<style scoped>
.map-item-wrapper {
  border-bottom: 1px solid #ebeef5;
  margin-top: 10px;
  padding-bottom: 5px;
}

.map-thumb-wrapper {
  text-align: left;
}
.card-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-actions {
  width: 100px;
}
.map-name {
  text-align: left;
  flex: 1;
}
.el-button {
  margin: 0 5px 0 0 !important;
}
.el-card {
  border: 1px solid #fc4c02;
  margin-top: 5px;
}
</style>
